import { render } from "./FamilyList.vue?vue&type=template&id=f9695b8c&scoped=true"
import script from "./FamilyList.vue?vue&type=script&lang=js"
export * from "./FamilyList.vue?vue&type=script&lang=js"

import "./FamilyList.vue?vue&type=style&index=0&id=f9695b8c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9695b8c"]])

export default __exports__